var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 8,
    viewBox: "0 0 37 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1417_64856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9924 3.53007L34.2663 3.46007V4.35607L32.9924 4.30007L33.7344 5.32207L32.9364 5.79807L32.3064 4.65007L31.6764 5.79807L30.8924 5.32207L31.6204 4.30007L30.3604 4.35607V3.46007L31.6204 3.53007L30.8924 2.49407L31.6764 2.01807L32.3064 3.16607L32.9364 2.01807L33.7344 2.49407L32.9924 3.53007Z",
    fill: "#727190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4826 3.53007L28.7566 3.46007V4.35607L27.4826 4.30007L28.2246 5.32207L27.4266 5.79807L26.7966 4.65007L26.1666 5.79807L25.3826 5.32207L26.1106 4.30007L24.8506 4.35607V3.46007L26.1106 3.53007L25.3826 2.49407L26.1666 2.01807L26.7966 3.16607L27.4266 2.01807L28.2246 2.49407L27.4826 3.53007Z",
    fill: "#727190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9728 3.53007L23.2468 3.46007V4.35607L21.9728 4.30007L22.7148 5.32207L21.9168 5.79807L21.2868 4.65007L20.6568 5.79807L19.8728 5.32207L20.6008 4.30007L19.3408 4.35607V3.46007L20.6008 3.53007L19.8728 2.49407L20.6568 2.01807L21.2868 3.16607L21.9168 2.01807L22.7148 2.49407L21.9728 3.53007Z",
    fill: "#727190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4631 3.53007L17.7371 3.46007V4.35607L16.4631 4.30007L17.2051 5.32207L16.4071 5.79807L15.7771 4.65007L15.1471 5.79807L14.3631 5.32207L15.0911 4.30007L13.8311 4.35607V3.46007L15.0911 3.53007L14.3631 2.49407L15.1471 2.01807L15.7771 3.16607L16.4071 2.01807L17.2051 2.49407L16.4631 3.53007Z",
    fill: "#727190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9533 3.53007L12.2273 3.46007V4.35607L10.9533 4.30007L11.6953 5.32207L10.8973 5.79807L10.2673 4.65007L9.63729 5.79807L8.85329 5.32207L9.58129 4.30007L8.32129 4.35607V3.46007L9.58129 3.53007L8.85329 2.49407L9.63729 2.01807L10.2673 3.16607L10.8973 2.01807L11.6953 2.49407L10.9533 3.53007Z",
    fill: "#727190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44352 3.53007L6.71752 3.46007V4.35607L5.44352 4.30007L6.18552 5.32207L5.38752 5.79807L4.75752 4.65007L4.12752 5.79807L3.34352 5.32207L4.07152 4.30007L2.81152 4.35607V3.46007L4.07152 3.53007L3.34352 2.49407L4.12752 2.01807L4.75752 3.16607L5.38752 2.01807L6.18552 2.49407L5.44352 3.53007Z",
    fill: "#727190"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1417_64856",
    x: 0.811523,
    y: 0.0180664,
    width: 35.4551,
    height: 7.78003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1417_64856"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlank);
export default __webpack_public_path__ + "static/media/blank.1b854891c0a4ad114c0b2360c637020f.svg";
export { ForwardRef as ReactComponent };